import { apiPost } from "../../shared/api";

/** Conti di una riga ordine (Piano 5): Decimal come stringhe, null = non noto.
 *  cost_source: 'catalogo' (stima dal mirror AM) | 'n/d' (costo sconosciuto). */
export interface OrderMarginLine {
  sku: string;
  title: string;
  quantity: number;
  line_gross: string;
  line_net: string;
  commission: string;
  shipping: string;
  packaging: string;
  product_cost: string | null;
  margin: string | null;
  margin_percent: string | null;
  cost_source: "catalogo" | "n/d";
  reasons: string[];
}

export interface OrderMarginRow {
  reference: string;
  channel: string;
  marketplace_id: string | null;
  gross_revenue: string;
  net_revenue: string | null;
  vat: string | null;
  commission: string | null;
  shipping: string | null;
  packaging: string | null;
  product_cost: string | null;
  supplier_cost: string | null;
  total_cost: string | null;
  margin: string | null;
  margin_percent: string | null;
  computable: boolean;
  is_estimate: boolean;
  estimate_reasons: string[];
  /** L'imballo è già dentro `supplier_cost` (il fornitore ha fatturato la riga
   *  «Bancale per…»): il backend NON l'ha sommato a `total_cost`, quindi qui
   *  non va mostrato come detrazione o la colonna non quadra. `packaging`
   *  resta il valore vero, non azzerato. Opzionale di proposito: obbligatorio
   *  romperebbe cinque fixture tipizzate senza guadagno. */
  packaging_in_supplier_cost?: boolean;
  /** Conti per-riga (Piano 5): il backend lo emette SEMPRE (default_factory). */
  lines: OrderMarginLine[];
}

interface ApiResponse {
  orders: OrderMarginRow[];
  computable_count: number;
  estimate_count: number;
  not_computable_count: number;
  params_synced_at?: string | null;
}

export interface OrderMarginSummary {
  orders: OrderMarginRow[];
  computableCount: number;
  estimateCount: number;
  notComputableCount: number;
  /** ISO 8601 o null: freschezza del mirror parametri AM (Piano 3). */
  paramsSyncedAt: string | null;
}

export async function fetchOrderMarginSummary(references: string[]): Promise<OrderMarginSummary> {
  const res = await apiPost<ApiResponse>("/api/economics/order-summary", { references });
  return {
    orders: res.orders,
    computableCount: res.computable_count,
    estimateCount: res.estimate_count,
    notComputableCount: res.not_computable_count,
    paramsSyncedAt: res.params_synced_at ?? null,
  };
}
